(function () {
	const emblaInstances = new Map();
	const emblaCleanupByViewport = new Map();
	const EPSILON_PX = 1;

	function isAutoplayEnabled(root) {
		const autoplayAttr = (root.dataset.productsAutoplay || "").toLowerCase();
		return autoplayAttr === "true" || autoplayAttr === "1" || autoplayAttr === "yes";
	}

	function isProductsCarouselStatic(viewport) {
		const slider = viewport.querySelector(".custom-article-products__slider");
		if (!slider) return true;
		return slider.scrollWidth <= viewport.clientWidth + EPSILON_PX;
	}

	function setStaticState(root, prevButton, nextButton, isStatic) {
		if (isStatic) {
			root.classList.add("custom-article-products__carousel--static");
			if (prevButton) prevButton.setAttribute("disabled", "disabled");
			if (nextButton) nextButton.setAttribute("disabled", "disabled");
			return;
		}

		root.classList.remove("custom-article-products__carousel--static");
		if (prevButton) prevButton.removeAttribute("disabled");
		if (nextButton) nextButton.removeAttribute("disabled");
	}

	function destroyEmblaForViewport(viewport) {
		const embla = emblaInstances.get(viewport);
		if (embla) {
			embla.destroy();
			emblaInstances.delete(viewport);
		}
		const cleanup = emblaCleanupByViewport.get(viewport);
		if (cleanup) {
			cleanup();
			emblaCleanupByViewport.delete(viewport);
		}
		viewport.dataset.emblaInitialized = "false";
	}

	function initProductsEmblaForViewport(viewport, root, prevButton, nextButton) {
		if (viewport.dataset.emblaInitialized === "true") return;

		const autoPlayEnabled = isAutoplayEnabled(root);
		const speedAttr = root.dataset.productsSpeed;
		const speedMs = (Number(speedAttr) || 5) * 1000;

		const options = {
			loop: false,
			align: "center",
			dragFree: true,
		};

		const plugins = [];
		if (autoPlayEnabled && typeof EmblaCarouselAutoplay === "function") {
			plugins.push(
				EmblaCarouselAutoplay({
					delay: speedMs,
					playOnInit: true,
					stopOnInteraction: false,
				}),
			);
		}

		const embla = EmblaCarousel(viewport, options, plugins);
		emblaInstances.set(viewport, embla);

		if (autoPlayEnabled) {
			embla.plugins().autoplay?.play();
		}

		const stopAutoplay = () => {
			const autoplay = embla?.plugins()?.autoplay;
			if (autoplay) autoplay.stop();
		};

		setStaticState(root, prevButton, nextButton, false);

		const onPrevClick = () => {
			stopAutoplay();
			embla.scrollPrev();
		};
		const onNextClick = () => {
			stopAutoplay();
			embla.scrollNext();
		};

		if (prevButton) prevButton.addEventListener("click", onPrevClick);
		if (nextButton) nextButton.addEventListener("click", onNextClick);

		emblaCleanupByViewport.set(viewport, () => {
			if (prevButton) prevButton.removeEventListener("click", onPrevClick);
			if (nextButton) nextButton.removeEventListener("click", onNextClick);
		});

		viewport.dataset.emblaInitialized = "true";
	}

	function evaluateViewport(viewport) {
		const root = viewport.closest(".custom-article-products__carousel");
		if (!root) return;

		const prevButton = root.querySelector("[data-products-prev]");
		const nextButton = root.querySelector("[data-products-next]");
		const shouldBeStatic = isProductsCarouselStatic(viewport);
		const hasEmbla = emblaInstances.has(viewport);

		if (shouldBeStatic) {
			if (hasEmbla) destroyEmblaForViewport(viewport);
			setStaticState(root, prevButton, nextButton, true);
			return;
		}

		if (!hasEmbla) {
			initProductsEmblaForViewport(viewport, root, prevButton, nextButton);
		}
	}

	function initEmblaTopicsProducts() {
		if (typeof EmblaCarousel !== "function") return false;

		const viewports = document.querySelectorAll(".custom-article-products__viewport[data-embla-products]");
		if (!viewports.length) return true;

		const needsAutoplayPlugin = Array.from(viewports).some((viewport) => {
			const root = viewport.closest(".custom-article-products__carousel");
			if (!root) return false;
			return isAutoplayEnabled(root);
		});

		if (needsAutoplayPlugin && typeof EmblaCarouselAutoplay !== "function") {
			return false;
		}

		viewports.forEach((viewport) => {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					evaluateViewport(viewport);
				});
			});

			if (!viewport.dataset.emblaObserverAttached) {
				const onResize = () => {
					evaluateViewport(viewport);
				};
				window.addEventListener("resize", onResize);
				viewport.dataset.emblaObserverAttached = "true";

				if (typeof ResizeObserver === "function") {
					const resizeObserver = new ResizeObserver(() => {
						evaluateViewport(viewport);
					});
					resizeObserver.observe(viewport);
					const slider = viewport.querySelector(".custom-article-products__slider");
					if (slider) resizeObserver.observe(slider);
				}
			}
		});

		return true;
	}

	function runWhenReady() {
		if (initEmblaTopicsProducts()) return;

		const onLoad = () => {
			initEmblaTopicsProducts();
		};

		if (document.readyState === "complete") {
			onLoad();
		} else {
			window.addEventListener("load", onLoad);
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", runWhenReady);
	} else {
		runWhenReady();
	}
})();
